import styled from 'styled-components';
import { COLORS } from '../../../../func/components/Color';

interface RegionModalProps {
  selected?: boolean;
  active?: boolean;
  smallDevice?: boolean;
}

export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.52);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
  box-shadow:
    0px 2px 8px 0px rgba(0, 0, 0, 0.12),
    0px 1px 4px 0px rgba(0, 0, 0, 0.08),
    0px 0px 1px 0px rgba(0, 0, 0, 0.08);
`;

export const ModalInner = styled.div<RegionModalProps>`
  width: 100%;
  height: ${({ smallDevice }) => '100%'};
  background-color: white;
  border-radius: 20px 20px 0 0;
  position: relative;

  display: flex;
  flex-direction: column;
`;

export const ModalTitle = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: Spoqa Han Sans Neo;

  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.labelNeutral};
  border-bottom: 1px solid ${COLORS.lineNormal};
  height: 56px;
`;

export const Section = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${COLORS.white};
  height: 144px;
`;

export const SectionBox = styled.div`
  width: 100%;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  background-color: white;
  border-top: 1px solid ${COLORS.lineNormal};

  /* 스크롤바 숨기기 */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE, Edge */
  scrollbar-width: none; /* Firefox */
`;

export const SectionLabel = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 16px;
  color: black;
  display: flex;
  justify-content: space-between;
`;
export const SelectedRegionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 16px 10px;
  background-color: rgba(112, 115, 124, 0.05);
  border-radius: 8px;
`;
export const RegionText = styled.span`
  font-family: Spoqa Han Sans Neo;

  font-size: 16px;
  color: ${COLORS.interactionNeutral};
  flex: 1;
  white-space: nowrap;
  text-align: center;
`;
export const SelectedRegionText = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  color: ${COLORS.labelNormal};
  flex: 1;
  white-space: nowrap;
`;

export const OptionColumn30 = styled.div`
  flex: 0.3;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  display: block;
  border-right: 1px solid ${COLORS.lineNormal};

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
export const OptionColumn40 = styled.div`
  flex: 0.4;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  display: block;
  border-right: 1px solid ${COLORS.lineNormal};

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const OptionItem = styled.span<RegionModalProps>`
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;

  font-size: 14px;
  color: ${({ selected }) =>
    selected ? COLORS.labelNormal : COLORS.labelAlternative};
  background-color: ${({ selected }) =>
    selected ? COLORS.white : COLORS.backgroundNeutral};
`;
export const OptionItemBg = styled.span<RegionModalProps>`
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;

  font-size: 14px;
  color: ${({ selected }) => (selected ? '#008AFF' : COLORS.labelNormal)};
  background-color: ${({ selected }) => (selected ? '#edf6ff' : COLORS.white)};
`;

export const ApplyBtnBox = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  background-color: ${COLORS.white};
  border-top: 1px solid ${COLORS.lineNormal};
  flex-shrink: 0;
`;

export const ResetBtn = styled.div`
  padding: 7px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${COLORS.lineNormal};
  cursor: pointer;
`;

export const ResetBtnText = styled.span`
  font-family: Spoqa Han Sans Neo;

  font-size: 10px;
  color: ${COLORS.labelAlternative};
`;
export const ApplyBtn = styled.span<RegionModalProps>`
  flex: 1;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-family: Spoqa Han Sans Neo;

  font-size: 16px;
  color: ${({ active }) => (active ? COLORS.white : COLORS.labelDisable)};
  background-color: ${({ active }) =>
    active ? '#008AFF' : COLORS.interactionDisable};
  cursor: pointer;
`;
